import { useNewStrategyContext } from './NewStrategyContext';
import { Confirm } from './Confirm';
import { useTranslation } from 'react-i18next';

export const Cancel = () => {
  const { closeConfirmModal, closeModal } = useNewStrategyContext();

  const { t } = useTranslation();
  return (
    <Confirm
      saveButtonMane="Quit"
      saveButtonVariant={'negative'}
      subtitle={t('strategies.newStrategy.cancel.title')}
      title={t('strategies.newStrategy.cancel.subtitle')}
      onCancel={closeConfirmModal!}
      onSave={closeModal!}
    />
  );
};
